import { defineMessages } from "react-intl";

const messages = defineMessages({
  modelContent1: {
    defaultMessage: "Are you sure you want to delete this comment?",
    description: "The 1st part of model content of deleting comment",
  },
  modelContent2: {
    defaultMessage: "There is no undo.",
    description: "The 2nd part of model content of deleting comment",
  },
  cancel: {
    defaultMessage: "Cancel",
    description: "Button content of canceling this deleting attempt",
  },
  delete: {
    defaultMessage: "Delete comment",
    description: "The content of describing this deletion",
  },
});

export default messages;
